import { resolveAppConfig } from './app-config';

export { APP_ID } from './app-config';

/** The configuration this bundle was built for (from the Vite `--mode`). */
export const APP_CONFIG = resolveAppConfig(import.meta.env.MODE);
